import { dynamic } from '#/utils/dynamic';

export const DynamicSearchInternshipRefinements = dynamic(
  () =>
    import('./SearchInternshipRefinements').then((m) => ({
      default: m.SearchInternshipRefinements,
    })),
  { strategy: 'client-only' },
);
